import { useRef, useState } from 'react';
import { Title, Button, MessageForm } from '@/components';
import { Container } from '@/containers';
import Router from 'next/router';
import Icon from '@/assets/icons';

import styles from './Contacts.module.scss';

// const ShopsMap = dynamic(() => import('../shopsMap/ShopsMap'), {
//   loading: () => <Loader />,
// });

const Contacts = () => {
	const infoRef = useRef(null);
	const [isOpen, setIsOpen] = useState(false);
	const toggleDrawer = () => {
		setIsOpen(prevState => !prevState);
	};
	// const [height, setHeight] = useState();

	// const onResize = useCallback(() => {

	//   setHeight(infoRef.current.clientHeight);
	// }, []);

	// useEffect(() => {
	//   onResize();
	//   window.addEventListener('resize', onResize);

	//   return () => {
	//     window.removeEventListener('resize', onResize);
	//   };
	// }, [onResize]);

	return (
		<>
			{/* <div className={clsx(styles.mapAddress, styles.visibleMap)}>
        <div className={styles.map} style={{ height: height }}>
          <ShopsMap
            isContact
            shops={shopInfo} />
        </div>
      </div> */}
			<Container>
				<MessageForm isOpen={isOpen} toggleDrawer={toggleDrawer} />
				<div className={styles.info} ref={infoRef}>
					<Title component='h2' className={styles.title}>
						ОДО «БелВиринея»
					</Title>

					<div className={styles.phoneInfo}>
						<a className={styles.phone} href='tel:+375296332633'>
							<Icon name='phone-fill-contacts' className={styles.icon} />
							+375 (29) 633-2-633
						</a>
						<div className={styles.time}>
							Время работы: <span>09:00 — 21:00</span>
						</div>
					</div>

					<div className={styles.addressInfo}>
						<h4 className={styles.addressTitle}>Юридический и почтовый адрес</h4>
						<div className={styles.legal}>
							<div className={styles.name}>ОДО «БелВиринея» УНП 190706320</div>
							<div className={styles.address}>
								<Icon name='shop-map' className={styles.iconPin} />
								г. Минск, ул. Немига 5, пом.39
							</div>
						</div>
					</div>

					<div className={styles.addressInfo}>
						<h4 className={styles.addressTitle}>Специалист по качеству</h4>
						<div className={styles.phoneInfo}>
							<a className={styles.phone} href='tel:+375445849765'>
								<Icon name='phone-fill-contacts' className={styles.icon} />
								+375 (44) 584-97-65
							</a>
							<div className={styles.time}>
								Время работы: <span>Пн-Пт: с 9:00 до 18:00, Сб-Вс: выходной</span>
							</div>
						</div>
					</div>

					<div className={styles.mails}>
						<div>
							<div className={styles.mailsBlock}>
								<div>По общим вопросам</div>
								<a className={styles.mail} href='mailto:fh@fh.by'>
									<Icon name='envelope' className={styles.icon} />
									fh@fh.by
								</a>
							</div>

							<div className={styles.mailsBlockMobile}>
								<div>По вопросам замечаний и предложений</div>
								<a className={styles.mail} href='mailto:otzyv@fh.by'>
									<Icon name='envelope' className={styles.icon} />
									otzyv@fh.by
								</a>
							</div>
						</div>

						<div>
							<div className={styles.mailsBlock}>
								<div>По вопросам рекламы</div>
								<a className={styles.mail} href='mailto:reklama@fh.by'>
									<Icon name='envelope' className={styles.icon} />
									reklama@fh.by
								</a>
							</div>
							<div className={styles.mailsBlockMobile}>
								<div>По вопросам трудоустройства</div>
								<a className={styles.mail} href='mailto:personal@fh.by'>
									<Icon name='envelope' className={styles.icon} />
									personal@fh.by
								</a>
							</div>
						</div>
					</div>

					<Button
						type='defaultBlack'
						classNames={{ general: styles.button }}
						onClick={() => {
							Router.push('/store-addresses');
						}}
					>
						Адреса магазинов
					</Button>
					<Button
						type='defaultBlack'
						classNames={{ general: styles.button }}
						onClick={() => {
							toggleDrawer();
						}}
					>
						Написать нам
					</Button>
				</div>
			</Container>
			{/* 
      <div className={clsx(styles.mapAddress, styles.invisibleMap)} >
        <div className={styles.map}>
          <ShopsMap
            shops={shopInfo} />
        </div>
      </div> */}
		</>
	);
};

export default Contacts;
